export default "__VITE_ASSET__8634eb2a__"